import React, {Component} from "react";
import {observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingImage from "../../../comum/components/LoadingImage";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {Col, Row} from "reactstrap";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';

@observer
export class TabelaAgendamentoDashboardGeral extends Component{
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {

        let lista =  this.controller.listaDashboardDados.ListaDashGeral.length > 0 ?  this.controller.listaDashboardDados.ListaDashGeral : [];
        let loading = this.controller.loading;

        return(

            !this.controller.filtrado 
            ? <Row>
                    <Col xs={12}>
                        <span className="mensagem-filtrar">
                            {buscaFiltrarVazio}
                        </span>
                    </Col>
                </Row>
            : <ToolkitProvider
                keyField="Ordem"
                data={lista.slice()}
                columns={[...this.controller.colunasGeral]}>
                {props => (
                    <div>
                        <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={() => loading ?
                                            <LoadingImage/> : (this.controller.filtrado && this.controller.tableMessage)}
                                        classes="tabela"
                                        pagination={ paginationFactory() }
                                        {...props.baseProps}/>
                    </div>)}
            </ToolkitProvider>

        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/dashboard/componentes/TabelaAgendamentoDashboardGeral.js